import * as Device from "redux-store/devices/selectors";
import { isSandbox } from "redux-store/networks";

const zeroStatsState = Object.freeze({
  percentOffline: 0,
  percentOnline: 0,
  prodHibernating: 0,
  prodOffline: 0,
  prodOnline: 0,
  prodTotal: 0,
  relativePercentHibernating: 0,
  sandboxHibernating: 0,
  sandboxOffline: 0,
  sandboxOnline: 0,
  sandboxTotal: 0,
  totalHibernating: 0,
  totalNeedsFirmwareUpgrade: 0,
  totalNeedsSoftwareUpgrade: 0,
  totalOffline: 0,
  totalOnline: 0,
});

function calcStats(devices, networks, deviceStatuses) {
  const stats = { ...zeroStatsState };

  Object.entries(devices).forEach(([id, d]) => {
    if (!d) {
      console.warn(`Invalid device detected (id ${id}).`);
      return;
    }

    const ds = deviceStatuses[id];
    const network = networks[d.network_id];

    if (!ds || !network) {
      return;
    }

    if (isSandbox(network) || Device.isTesting(d)) {
      stats.sandboxTotal++;

      if (ds.online) {
        stats.sandboxOnline++;
        stats.totalOnline++;
      } else {
        stats.sandboxOffline++;
        stats.totalOffline++;
      }

      if (ds.hibernating) {
        stats.sandboxHibernating++;
        stats.totalHibernating++;
      }
    } else {
      stats.prodTotal++;

      if (ds.online) {
        stats.prodOnline++;
        stats.totalOnline++;
      } else {
        stats.prodOffline++;
        stats.totalOffline++;
      }

      if (ds.hibernating) {
        stats.prodHibernating++;
        stats.totalHibernating++;
      }
    }

    if (Device.needsSoftwareUpgrade(d)) {
      stats.totalNeedsSoftwareUpgrade += 1;
    }

    if (Device.needsFirmwareUpgrade(d)) {
      stats.totalNeedsFirmwareUpgrade += 1;
    }
  });

  Object.assign(stats, _calcOnlinePercent(stats));
  Object.assign(stats, _calcHibernatingPercent(stats));

  return stats;
}

function calcPercent(a, b) {
  return b > 0 ? Math.floor((a / b) * 100) : 0;
}

function _calcOnlinePercent(stats) {
  const percentOnline = calcPercent(stats.prodOnline, stats.prodTotal);

  return {
    percentOnline: percentOnline,
    percentOffline: 100 - percentOnline,
  };
}

function _calcHibernatingPercent(stats) {
  const relativePercentHibernating = calcPercent(
    stats.prodHibernating,
    stats.prodOnline,
  );

  return {
    relativePercentHibernating,
  };
}

export {
  _calcHibernatingPercent,
  _calcOnlinePercent,
  calcPercent,
  calcStats,
  zeroStatsState,
};
